import ReportsMenu from "./ReportsMenu";
import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import { Link, NavLink } from "react-router-dom";
import moment from "moment";
import Pagination from "../General/Pagination";
import { Form } from "react-bootstrap";
import MonthsDropDown from "../Shared/MonthsDropDown";
import YearsDropDown from "../Shared/YearsDropDown";
import { calculateColumnTotal } from "../General/Utility";

const ArrearsRecoveryReport = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [showFilters, setShowFilters] = useState(true);
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [validated, setValidated] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalArrearsRecovered, setTotalArrearsRecovered] = useState(0);
  const [totalRecoverableFee, setTotalRecoverableFee] = useState(0);
  const [grandTotalArrears, setGrandTotalArrears] = useState(0);
  const [totalPendingArrears, setTotalPendingArrears] = useState(0);
  const [includePendingArrears, setIncludePendingArrears] = useState(false);

  const [Wing, setWing] = useState("");
  const [Section, setSection] = useState("");
  const [Session, setSession] = useState(
    () => localStorage.getItem("DefaultSession") || ""
  );
  const [Class, setClass] = useState("");
  const [ReportMonth, setReportMonth] = useState(moment().format("M"));
  const [ReportYear, setReportYear] = useState(moment().format("YYYY"));
  const [OrderBy, setOrderBy] = useState("Wing_Name,Class_Name,Section_Name");

  document.title = "Arrears Recovery Report";

  useEffect(() => {
    const ry = parseInt(String(ReportYear).trim(), 10);
    const rm = parseInt(String(ReportMonth).trim(), 10);
    if (!Number.isFinite(ry) || ry <= 0 || !Number.isFinite(rm) || rm <= 0) {
      setLedger([]);
      setTotalRecords(0);
      setTotalArrearsRecovered(0);
      setTotalRecoverableFee(0);
      setGrandTotalArrears(0);
      setTotalPendingArrears(0);
      return;
    }

    setLoading(true);
    const w = parseInt(String(Wing).trim(), 10);
    const c = parseInt(String(Class).trim(), 10);
    const s = parseInt(String(Section).trim(), 10);
    const sid = parseInt(String(Session).trim(), 10);

    axios({
      method: "post",
      url: config.base_url + "Reports/GetArrearsRecoveryReport",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        pageNo,
        pageSize,
        ReportYear: ry,
        ReportMonth: rm,
        Wing_Id: Number.isFinite(w) ? w : 0,
        Class_Id: Number.isFinite(c) ? c : 0,
        Section_Id: Number.isFinite(s) ? s : 0,
        SessionID: Number.isFinite(sid) && sid > 0 ? sid : 0,
        OrderBy,
        IncludePendingArrears: includePendingArrears,
      },
    })
      .then(function (response) {
        const rows = Array.isArray(response.data.ListofRecords)
          ? response.data.ListofRecords
          : [];
        setLedger(rows);
        setTotalRecords(response.data.totalRecords || 0);
        setTotalArrearsRecovered(response.data.TotalArrearsRecovered || 0);
        setTotalRecoverableFee(response.data.TotalRecoverableFee || 0);
        setGrandTotalArrears(response.data.GrandTotalArrears || 0);
        setTotalPendingArrears(response.data.TotalPendingArrears || 0);
        setLoading(false);
      })
      .catch(function () {
        setLedger([]);
        setTotalRecords(0);
        setTotalArrearsRecovered(0);
        setTotalRecoverableFee(0);
        setGrandTotalArrears(0);
        setTotalPendingArrears(0);
        setLoading(false);
      });
  }, [
    pageNo,
    pageSize,
    ReportYear,
    ReportMonth,
    Wing,
    Class,
    Section,
    Session,
    OrderBy,
    includePendingArrears,
  ]);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      return;
    }
    setReportYear(event.target.ReportYear.value);
    setReportMonth(event.target.ReportMonth.value);
    setSession(event.target.Session.value);
    setWing(event.target.Wing.value);
    setClass(event.target.Class.value);
    setSection(event.target.Section.value);
    setOrderBy(event.target.OrderBy.value);
    setIncludePendingArrears(!!event.target.IncludePendingArrears?.checked);
    setPageNo(1);
    setValidated(true);
  };

  const colSpan = includePendingArrears ? 9 : 8;

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => (
        <tr key={index}>
          <td>{item.Student_ID}</td>
          <td>{item.Registration_No}</td>
          <td>{item.Student_Name}</td>
          <td>{item.Father_Name}</td>
          <td>{item.Class_Name}</td>
          <td>{item.Section_Name}</td>
          <td className="text-end">{item.ArrearsRecovered}</td>
          {includePendingArrears && (
            <td className="text-end">{item.RecoverableFee}</td>
          )}
          <td className="text-end">{item.TotalArrears}</td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan={colSpan}>
          <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ReportsMenu />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/Reports/ReportsDashboard">Reports</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Arrears Recovery
                  </li>
                </ol>
              </nav>
              <div className="page-title">Arrears Recovery Report</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <button
                  type="button"
                  onClick={() => setShowFilters((v) => !v)}
                  className="button button-white button-icon"
                >
                  {showFilters ? "Hide Filters" : "Show Filters"}
                  <i className="ri-filter-3-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`collapse ${showFilters ? "show" : ""}`}>
        <div className="page-content">
          <div className="container">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <div className="card mb-2">
                <div className="card-body p-md-4">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label>Select Session:</label>
                        <select
                          className="form-select"
                          name="Session"
                          value={Session}
                          onChange={(e) => {
                            setSession(e.target.value);
                            setClass("");
                            setWing("");
                            setSection("");
                          }}
                        >
                          <option value="">---All---</option>
                          <SessionsDropDown />
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label>Select Wing:</label>
                        <select
                          name="Wing"
                          className="form-select"
                          value={Wing}
                          onChange={(e) => {
                            setWing(e.target.value);
                            setClass("");
                            setSection("");
                          }}
                        >
                          <option value="">---All---</option>
                          <WingsDropDown />
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label>Select Class:</label>
                        <select
                          className="form-select"
                          name="Class"
                          value={Class}
                          onChange={(e) => {
                            setClass(e.target.value);
                            setSection("");
                          }}
                        >
                          <option value="">---All---</option>
                          {Number(Session) > 0 && Number(Wing) > 0 && (
                            <ClassesDropDown SessionID={Session} WingID={Wing} />
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label>Select Section:</label>
                        <select
                          className="form-select"
                          name="Section"
                          value={Section}
                          onChange={(e) => setSection(e.target.value)}
                        >
                          <option value="">---All---</option>
                          {Class !== "" && Class !== "0" && (
                            <SectionDropDown ClassID={Class} />
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Challan Month:</label>
                        <select
                          name="ReportMonth"
                          value={ReportMonth}
                          onChange={(e) => setReportMonth(e.target.value)}
                          className="form-select"
                          required
                        >
                          <option value="">Please Select</option>
                          <MonthsDropDown />
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Challan Year:</label>
                        <select
                          name="ReportYear"
                          value={ReportYear}
                          onChange={(e) => setReportYear(e.target.value)}
                          className="form-select"
                          required
                        >
                          <option value="">Please Select</option>
                          <YearsDropDown />
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label className="d-block">&nbsp;</label>
                        <div className="form-check mt-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="IncludePendingArrears"
                            name="IncludePendingArrears"
                            checked={includePendingArrears}
                            onChange={(e) => setIncludePendingArrears(e.target.checked)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="IncludePendingArrears"
                          >
                            Include pending arrears
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Order By:</label>
                        <select
                          name="OrderBy"
                          value={OrderBy}
                          onChange={(e) => setOrderBy(e.target.value)}
                          className="form-select"
                        >
                          <option value="Student_Name">Student Name</option>
                          <option value="Registration_No">Registration No</option>
                          <option value="Wing_Name">Wing Name</option>
                          <option value="Class_Name">Class</option>
                          <option value="Wing_Name,Class_Name,Section_Name">
                            Wing, Class, Section
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2 offset-md-1 text-end">
                      <div className="form-group text-end">
                        <button
                          type="submit"
                          className="w-100 button button-primary mt-4"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body">
              <p className="text-muted small mb-2">
                {includePendingArrears
                  ? "Shows arrears recovered (paid) and pending arrears (unpaid) for the selected challan month. Total Arrears = Recovered + Pending."
                  : "Shows students who paid the selected month challan (PendingFee = 0) with arrears recovered."}
              </p>
              <table className="table table-theme">
                <thead>
                  <tr>
                    <th colSpan={4}>Total Records: {totalRecords}</th>
                    <th colSpan={colSpan - 4} className="text-end">
                      Recovered: {totalArrearsRecovered}
                      {includePendingArrears && (
                        <> | Pending: {totalPendingArrears}</>
                      )}
                      {" | "}Total Arrears: {grandTotalArrears}
                    </th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th>Student ID</th>
                    <th>Registration No.</th>
                    <th>Student Name</th>
                    <th>Father Name</th>
                    <th>Class</th>
                    <th>Section</th>
                    <th className="text-end">Arrears Recovered</th>
                    {includePendingArrears && (
                      <th className="text-end">Pending Arrears</th>
                    )}
                    <th className="text-end">Total Arrears</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td className="text-center" colSpan={colSpan}>
                        <Spinner animation="border" role="status" />
                      </td>
                    </tr>
                  ) : (
                    renderLedger()
                  )}
                  {!loading && listOfLedger.length > 0 && (
                    <tr>
                      <td colSpan={6} className="text-end">
                        <strong>Page total</strong>
                      </td>
                      <td className="text-end">
                        <strong>
                          {calculateColumnTotal(listOfLedger, "ArrearsRecovered")}
                        </strong>
                      </td>
                      {includePendingArrears && (
                        <td className="text-end">
                          <strong>
                            {calculateColumnTotal(listOfLedger, "RecoverableFee")}
                          </strong>
                        </td>
                      )}
                      <td className="text-end">
                        <strong>
                          {calculateColumnTotal(listOfLedger, "TotalArrears")}
                        </strong>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {totalRecords > pageSize && (
                <div className="pagination-wrap">
                  <div className="row align-items-center">
                    <div className="col-md-2 form_default">
                      <div className="d-flex align-items-center">
                        <label className="me-2" style={{ fontSize: "15px" }}>
                          Page Size
                        </label>
                        <select
                          className="form-select"
                          style={{ width: "100px" }}
                          value={pageSize}
                          onChange={(e) => {
                            setPageNo(1);
                            setPageSize(parseInt(e.target.value, 10));
                          }}
                        >
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                          <option value="1000">1000</option>
                        </select>
                      </div>
                    </div>
                    <Pagination
                      pageNo={pageNo}
                      pageSize={pageSize}
                      totalRecords={totalRecords}
                      onPageChange={setPageNo}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="container">
          <div className="card mt-2">
            <div className="card-body p-md-4 text-end">
              <NavLink
                className="button button-primary"
                to={`/Reports/ArrearsRecoveryReportPrint?ReportYear=${encodeURIComponent(ReportYear)}&ReportMonth=${encodeURIComponent(ReportMonth)}&Session_Id=${encodeURIComponent(Session)}&Wing_Id=${encodeURIComponent(Wing)}&Class_Id=${encodeURIComponent(Class)}&Section_Id=${encodeURIComponent(Section)}&OrderBy=${encodeURIComponent(OrderBy)}&IncludePendingArrears=${includePendingArrears ? "1" : "0"}`}
                target="_blank"
              >
                Print Report
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ArrearsRecoveryReport;
